import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import * as api from "../../redux/api";
import { Country } from "country-state-city";
import Loader from "../../components/loaders/Loader";
import { reactIcons } from "../../utils/icons";
import { useNavigate, useParams } from "react-router-dom";
import EntityFormRef from "../../components/Forms/EntityFormRef";
import CustomFileInput from "../../components/CustomFileInput";
import BackButton from "../../components/BackButton";

const initialState = {
  type: "",
  name: "",
  RegistrationNumber: "",
  emailAddress: "",
  phoneNumber: "",
  website: "",
  address: "",
  dateOfIncorporation: null,
  refineryMethodUsed: [],
  efficiencyMetrics: "",
  refineryCertification1: [],
  refineryCertification2: [],
  ol: [],
  ecl: [],
  refinerySustainabilityPractices: "",
  certificationFile1: "",
  certificationFile2: ""
};

const AddRefineries = () => {
  const [step1, setStep1] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [form, setForm] = useState(initialState);
  const [formError, setFormError] = useState({});
  const [dialCode, setDialCode] = useState("91");
  const [selectedCountry, setSelectedCountry] = useState("IN");
  const [countryName, setCountryName] = useState("India");
  const [cardImage, setCardImage] = useState("");
  const [cardImage1, setCardImage1] = useState("");
  const [isReadOnly, setIsReadOnly] = useState(false);

  const navigate = useNavigate();
  const [apiData, setApiData] = useState({});
  const { id } = useParams();
  const refiningOptions = [
    "electrolytic refining",
    "Miller process",
    "Wohlwill process"
  ];

  const getData = async () => {
    try {
      if (!id) return;

      const res = await api.getUserList(id);

      if (res?.status && res?.data?.data) {
        const { data: userData } = res.data;
        setApiData(res.data);

        const OrganizationMeta = userData?.OrganizationMeta?.[0] ?? {};
        const storageBaseUrl =
          "https://ventursa-api.codesfortomorrow.com/storage";

        // const refineryCertifications = (
        //   OrganizationMeta?.refineryCertification || []
        // ).map((filename) => ({
        //   name: filename,
        //   url: `${storageBaseUrl}/${filename}`
        // }));
        const cert1 = (OrganizationMeta?.refineryCertification1 || []).map(
          (url) => ({
            name: url.split("/").pop(),
            url
          })
        );

        const cert2 = (OrganizationMeta?.refineryCertification2 || []).map(
          (url) => ({
            name: url.split("/").pop(),
            url
          })
        );

        const isoCerts = (OrganizationMeta?.refineryIsoCertification || []).map(
          (filename) => ({
            name: filename,
            url: `${storageBaseUrl}/${filename}`
          })
        );

        const opLicenses = (
          OrganizationMeta?.refineryOperationalLicense || []
        ).map((filename) => ({
          name: filename,
          url: `${storageBaseUrl}/${filename}`
        }));

        // const mid = Math.ceil(refineryCertifications.length / 2);
        // const cert1 = refineryCertifications.slice(0, mid);
        // const cert2 = refineryCertifications.slice(mid);
        setIsReadOnly(true);

        setForm((prev) => ({
          ...prev,
          type: userData.type || "",
          name: userData.name || "",
          RegistrationNumber: userData.registrationNumber || "",
          emailAddress: userData.emailAddress || "",
          phoneNumber: userData.phoneNumber?.replace(/^\+?(\d{1,4})/, "") || "",
          website: userData.website || "",
          address: userData.address || "",
          dateOfIncorporation: userData.dateOfIncorporation
            ? new Date(userData.dateOfIncorporation)
            : null,
          refineryMethodUsed: OrganizationMeta?.refineryMethodUsed || "",
          refinerySustainabilityPractices:
            OrganizationMeta?.refinerySustainabilityPractices?.[0] || "",
          refineryCertification1: cert1,
          refineryCertification2: cert2,
          ol: isoCerts,
          ecl: opLicenses
        }));

        setCardImage(cert1);
        setCardImage1(cert2);
      } else {
        console.error("Error fetching data:", res?.message || "Unknown error");
      }
    } catch (error) {
      console.error("API Error:", error?.message || error);
    }
  };

  useEffect(() => {
    if (id) {
      getData();
    }
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({
      ...form,
      [name]: value
    });
    setFormError({
      ...formError,
      [name]: ""
    });
  };

  const handleStepComplete = (stepData) => {
    setForm({
      ...form,
      ...stepData
    });
    setStep1(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isLoading) return;

    const errors = {};

    if (!form.refineryMethodUsed?.length) {
      errors.refineryMethodUsed = "Select at least one refining method";
    }

    if (!form.refineryCertification1?.length) {
      errors.refineryCertification1 =
        "Please upload at least one certification file";
    }

    if (!form.refineryCertification2?.length) {
      errors.refineryCertification2 =
        "Please upload at least one ISO certification file";
    }

    if (!form.ol?.length) {
      errors.ol = "Please upload at least one ISO certification";
    }

    if (!form.ecl?.length) {
      errors.ecl = "Please upload at least one operational license";
    }

    if (Object.keys(errors).length) {
      setFormError(errors);
      return;
    }

    try {
      setIsLoading(true);

      const payload = {
        type: form.type,
        primaryContactName: form.primaryContactName,
        name: form.name,
        registrationNumber: form.RegistrationNumber,
        emailAddress: form.emailAddress,
        phoneNumber: `+${dialCode}${form.phoneNumber}`,
        website: form.website || "",
        address: form.address,
        dateOfIncorporation: form.dateOfIncorporation,
        dialCode: "+" + dialCode,
        country: countryName,
        countryOfIncorporation: form.countryOfIncorporation,
        refineryMethodUsed: form.refineryMethodUsed,
        efficiencyMetrics: form.efficiencyMetrics || "",
        refineryCertification1: cardImage || "",
        refineryCertification2: cardImage1 || "",
        documentationChecklist: {},
        beneficialOwners: [],
        complianceRiskAssessment: [],

        addedBy: "admin",
        organizationMeta: [
          {
            refineryMethodUsed: form.refineryMethodUsed,
            refinerySustainabilityPractices: [
              form.refinerySustainabilityPractices
            ],
            refineryCertification: [
              ...form.refineryCertification1.map((f) => f.name),
              ...form.refineryCertification2.map((f) => f.name)
            ],
            refineryIsoCertification: form.ol.map((f) => f.name),
            refineryOperationalLicense: form.ecl.map((f) => f.name)
          }
        ]
      };

      const res = await api.registerUser(payload);
      if (res.status === 200 || res.status === 201) {
        toast.success("Refineries Added Successfully");
        console.log(res, "resdasa");
        console.log("idchec121k", res.data.id);
        const id = res.data?.id || res.data?.organizationId;
        navigate(`/documentation-checklist/${id}`, {
          state: { key: "saurabh" }
        });
        localStorage.setItem("organizationId", res.data.organizationId);
      } else {
        toast.error(res?.error?.message);
      }
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        Array.isArray(error.response.data.message)
      ) {
        toast.error(error.response.data.message[0]);
      } else if (error.response && error.response.data) {
        toast.error(error.response.data.message);
      } else {
        toast.error("An error occurred while submitting the form");
      }
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCountryChange = (e) => {
    const countryCode = e.target.value;
    setSelectedCountry(countryCode);
    const country = Country.getAllCountries().find(
      (c) => c.isoCode === countryCode
    );
    setCountryName(country.name);
    setDialCode(country?.phonecode);
  };

  useEffect(() => {
    const country = Country.getAllCountries().find((c) => c.isoCode === "IN");
    if (country) {
      setCountryName(country.name);
    }
  }, []);
  const handleRefiningSelect = (method) => {
    setForm((prev) => {
      const arr = prev.refineryMethodUsed || [];
      const next = arr.includes(method)
        ? arr.filter((m) => m !== method)
        : [...arr, method];
      return { ...prev, refineryMethodUsed: next };
    });
    setFormError((prev) => ({ ...prev, refineryMethodUsed: "" }));
  };
  return (
    <div>
      <header className="flex items-center gap-2">
        <BackButton />
        <h4 className="">Add Refineries</h4>
      </header>
      <div className="border mt-5 border-yellow-dark   p-5 rounded-[10px]">
        <form
          onSubmit={(e) => {
            e.preventDefault();
            if (id) {
              navigate(`/documentation-checklist/${id}`);
            } else {
              handleSubmit(e);
            }
          }}
        >
          <div className="relative">
            {!step1 ? (
              <div className="font-semibold text-black text-20">
                Organization Information<span className="text-red-600">*</span>
              </div>
            ) : (
              <div className="font-semibold text-20 text-black">Refineries</div>
            )}
            {!step1 ? (
              <EntityFormRef
                handleChange={handleChange}
                formError={formError}
                handleCountryChange={handleCountryChange}
                selectedCountry={selectedCountry}
                Country={Country}
                dialCode={dialCode}
                onStepComplete={handleStepComplete}
                form={apiData?.data}
                isReadOnly={isReadOnly}
              />
            ) : (
              <div className="lg:grid grid-cols-1 sm:grid-cols-2 gap-6 items-start mt-4">
                <div className="mb-3 lg:mb-0">
                  <label className="mb-2 block text-black">
                    Refining method<span className="text-red-600">*</span>
                  </label>

                  <div className="flex gap-3 flex-wrap">
                    {refiningOptions.map((opt) => {
                      const selected = form.refineryMethodUsed.includes(opt);
                      return (
                        <button
                          key={opt}
                          type="button"
                          onClick={() => handleRefiningSelect(opt)}
                          disabled={isReadOnly}
                          className={`
          px-4 py-2 rounded-md border
          ${
            selected
              ? "bg-yellow-700 text-white border-yellow-700"
              : "bg-white text-black border-gray-300"
          }
          ${
            isReadOnly
              ? "opacity-50 cursor-not-allowed"
              : "hover:bg-yellow-100 hover:text-black"
          }
        `}
                        >
                          {opt}
                        </button>
                      );
                    })}
                  </div>

                  {formError.refineryMethodUsed && (
                    <div className="form-eror">
                      {formError.refineryMethodUsed}
                    </div>
                  )}
                </div>
                <div className="mb-3 lg:mb-0">
                  <label className="mb-2 block text-black">
                    Sustainability practices (if applicable)
                  </label>
                  <textarea
                    type="text"
                    placeholder="Enter Sustainability "
                    autoComplete="off"
                    name="refinerySustainabilityPractices"
                    onChange={handleChange}
                    // className="text-input text-black text-12 lg:text-14 border"
                    readOnly={isReadOnly}
                    value={form.refinerySustainabilityPractices}
                    className={`text-input ${
                      isReadOnly ? "readonly-input " : ""
                    }`}
                  />
                </div>

                <div>
                  <CustomFileInput
                    label="Certification 1"
                    allowedFormats="pdf"
                    name="refineryCertification1"
                    defaultValue={(form.refineryCertification1 || []).map(
                      (f) => f.url
                    )}
                    onChange={(urls) => {
                      const files = urls.map((url) => ({
                        name: url.split("/").pop(),
                        url
                      }));
                      setForm((prev) => ({
                        ...prev,
                        refineryCertification1: files
                      }));
                      setFormError((prev) => ({
                        ...prev,
                        refineryCertification1: ""
                      }));
                    }}
                    disabled={isReadOnly}
                  />
                  {formError.refineryCertification1 && (
                    <div className="form-eror">
                      {formError.refineryCertification1}
                    </div>
                  )}
                </div>
                <div>
                  <CustomFileInput
                    label="Certification 2"
                    allowedFormats="pdf"
                    name="refineryCertification2"
                    defaultValue={(form.refineryCertification2 || []).map(
                      (f) => f.url
                    )}
                    onChange={(urls) => {
                      const updated = urls.map((url) => ({
                        name: url.split("/").pop(),
                        url
                      }));
                      setForm((prev) => ({
                        ...prev,
                        refineryCertification2: updated
                      }));
                      setFormError((prev) => ({
                        ...prev,
                        refineryCertification2: ""
                      }));
                    }}
                    disabled={isReadOnly}
                  />
                  {formError.refineryCertification2 && (
                    <div className="form-eror">
                      {formError.refineryCertification2}
                    </div>
                  )}
                </div>

                <div>
                  <CustomFileInput
                    label="ISO Certification"
                    allowedFormats="pdf"
                    name="refineryIsoCertification"
                    defaultValue={(form.ol || []).map((f) => f.url)}
                    onChange={(urls) => {
                      const updated = urls.map((url) => ({
                        name: url.split("/").pop(),
                        url
                      }));
                      setForm((prev) => ({
                        ...prev,
                        ol: updated
                      }));
                      setFormError((prev) => ({
                        ...prev,
                        ol: ""
                      }));
                    }}
                    disabled={isReadOnly}
                  />
                  {formError.ol && (
                    <div className="form-eror"> {formError.ol}</div>
                  )}
                </div>
                <div>
                  <CustomFileInput
                    label="Operational License"
                    allowedFormats="pdf"
                    name="refineryOperationalLicense"
                    defaultValue={(form.ecl || []).map((f) => f.url)}
                    onChange={(urls) => {
                      const updated = urls.map((url) => ({
                        name: url.split("/").pop(),
                        url
                      }));
                      setForm((prev) => ({
                        ...prev,
                        ecl: updated
                      }));
                      setFormError((prev) => ({
                        ...prev,
                        ecl: ""
                      }));
                    }}
                    disabled={isReadOnly}
                  />
                  {formError.ecl && (
                    <div className="form-eror">{formError.ecl}</div>
                  )}
                </div>
              </div>
            )}
          </div>
          {!step1 ? (
            <div className="flex gap-2 mt-5 justify-end items-center"></div>
          ) : (
            <div className="flex gap-2 mt-5 justify-end items-center">
              <button
                type="button"
                onClick={() => setStep1(false)}
                className={`btn btn-danger `}
              >
                {reactIcons.arrowleft} Back
              </button>
              <button
                type="submit"
                disabled={isLoading || !form.refineryMethodUsed}
                className={`btn btn-primary ${
                  isLoading || !form.refineryMethodUsed
                    ? "bg-red-500 border-red-500 opacity-50 disabled:pointer-events-none"
                    : undefined
                }`}
              >
                {isLoading ? <Loader /> : "Next"}
              </button>
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default AddRefineries;
